import { EcommerceService } from 'services'

export default class AffiliateService extends EcommerceService {
  register(payload: any) {
    const req = this.setUrl('/afiliados').post(payload)
    return req
  }
} 